import React, { useState } from 'react';

import { IconButton, Typography } from '@mui/material';
import { AlineTooltip, Spacer } from 'src/components';
import { BackArrowIcon } from 'src/components/icons/BackArrowIcon';
import { CompleteReminderButton } from 'src/components/reminders/CompleteReminderButton';
import { useBackToAI } from 'src/editor/toolbars/right-panel/BackToAIButton';
import type { Apollo } from 'src/gql/generated';
import { makeStyles } from 'tss-react/mui';

export const useReminderHeaderStyles = makeStyles()(theme => ({
  header: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    position: 'sticky',
  },
  text: {
    fontWeight: 600,
  },
}));

export function ReminderDetailsHeader({
  reminder,
}: {
  reminder: Pick<Apollo.Reminder, 'completedAt' | 'id' | '__typename'>;
}) {
  const { classes } = useReminderHeaderStyles();
  const handleBackToAI = useBackToAI();
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <div className={classes.header}>
      <AlineTooltip
        arrow
        open={tooltipOpen}
        placement="top"
        title="Back to AI"
        onClose={() => setTooltipOpen(false)}
        onOpen={() => setTooltipOpen(true)}
      >
        <IconButton size="small" onClick={handleBackToAI}>
          <BackArrowIcon />
        </IconButton>
      </AlineTooltip>
      <CompleteReminderButton disableTooltip reminder={reminder}>
        <Typography className={classes.text}>
          {reminder.completedAt ? 'Reopen' : 'Mark complete'}
        </Typography>
      </CompleteReminderButton>
      <Spacer />
    </div>
  );
}
